/* eslint-disable */
// src/forms/machine/createMachineForm.js

import React, { Component } from "react";
import machineService from "../../services/machineService";
import formulaService from "../../services/formulaService";
import machineTypeService from "../../services/machineTypeService";
import PropTypes from "prop-types";
import {
  Button,
  Box,
  TextField,
  Grid,
  Container,
  Paper,
  Typography,
  Modal,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Autocomplete,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import esLocale from 'date-fns/locale/es'; 
import CancelButton from "components/common/CancelButton";
import AcceptButton from "components/common/AcceptButton";
import {
  getDefaultOperationDate,
  isFutureOperationDate,
  isValidOperationDate,
} from "utils/operationDate";
import { secondaryOutlinedButtonSx } from "components/common/buttonStyles";

class CreateMachineForm extends Component {
  constructor(props){
    super(props);
    this.state = {
      machine: {
        Name: "",
        SerialNumber: "",
        CreationDate: new Date(),
        MachineTypeId: "",
      },
      machineTypes: [],
      selectedMachineType: null,
      isLoading: true,
      serialSuggestion: null,
      serialError: "",
      generalError: "",
      showRequiredErrors: false,
    }
    this.serialDebounceTimer = null;
    this.serialCheckSeq = 0;
  }

  async componentDidMount() {
    try {
      const machineTypesData = await machineTypeService.getMachineTypes();
      
      const selectedMachineType = this.state.machine.MachineTypeId
        ? machineTypesData.find(machineType => machineType.Id === this.state.machine.MachineTypeId)
        : null;

      this.setState({
        machineTypes: machineTypesData,
        selectedMachineType,
        isLoading: false,
      });

    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false });
    }
  }

  // Maneja cambios en los campos del formulario
    handleChange = (event) => {
    const { name, value } = event.target;

    this.setState(
      (prevState) => ({
        machine: {
          ...prevState.machine,
          [name]: value,
        },
        generalError: "",
        // opcional: mientras escribe, limpiamos el error anterior (se recalcula con debounce)
        ...(name === "SerialNumber" ? { serialError: "" } : {}),
      }),
      () => {
        if (name === "SerialNumber") {
          this.scheduleSerialValidation(value);
        }
      }
    );
  };

  handleAutocompleteChange = async (field, event, value) => {
    const typeId = value ? value.Id : "";

    if (this.serialDebounceTimer) clearTimeout(this.serialDebounceTimer);
    this.serialCheckSeq += 1;
    
    this.setState((prev) => ({
      machine: { ...prev.machine, [field]: typeId },
      selectedMachineType: value,
      serialSuggestion: null,
      serialError: "",
      generalError: "",
      machine: {
        ...prev.machine,
        [field]: typeId,
        SerialNumber: "",
      },
    }), async () => {
      if (typeId) {
        const suggestion = await machineService.getSerialSuggestion(typeId);
        this.setState({ serialSuggestion: suggestion });
      }
    });
  };

  applySuggestion = async () => {
    const s = this.state.serialSuggestion;
    if (!s) return;

    this.setState((prev) => ({
      machine: { ...prev.machine, SerialNumber: s },
      serialError: "",
    }));

     this.scheduleSerialValidation(s);
  };

   scheduleSerialValidation = (rawValue) => {
    // limpia timer anterior
    if (this.serialDebounceTimer) clearTimeout(this.serialDebounceTimer);

    const serial = String(rawValue || "").trim();

    if (!serial) {
      this.setState({ serialError: "", generalError: "" });
      return;
    }

    this.serialDebounceTimer = setTimeout(async () => {
      const seq = ++this.serialCheckSeq;

      try {
        const exists = await machineService.serialExists(serial);

        if (seq !== this.serialCheckSeq) return;

        this.setState({ serialError: exists ? "Ya existe, elegir otro" : "" });
      } catch (e) {
        if (seq !== this.serialCheckSeq) return;
        this.setState({ serialError: "" });
      }
    }, 300);
  };

  handleDateChange = (date) => {
    this.setState((prevState) => ({
      machine: {
        ...prevState.machine,
        CreationDate: date,
      },
      generalError: "",
    }));
  };

  getCreationDateErrorMessage = () => {
    const date = this.state.machine.CreationDate;
    if (!isValidOperationDate(date)) return "Selecciona una fecha válida.";
    if (isFutureOperationDate(date)) return "No se puede seleccionar una fecha futura.";
    return "";
  };

  toDateOnlyString = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Maneja el envío del formulario
    handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ generalError: "" });
    const { MachineTypeId, Name, SerialNumber } = this.state.machine;
    const creationDateError = this.getCreationDateErrorMessage();
    if (!MachineTypeId || !Name.trim() || !SerialNumber.trim() || creationDateError || this.state.serialError) {
      this.setState({ showRequiredErrors: true });
      return;
    }
    try {
      const payload = { ...this.state.machine };
      payload.CreationDate = this.toDateOnlyString(payload.CreationDate);

      console.log("Enviando máquina:", payload);

      const res = await machineService.createMachine(payload);

      // soporta: { id, machine } o directamente un id (por si cambiaste algo)
      const newId = res?.id ?? res?.Id ?? res;

      await this.props.onCreateSuccess?.(newId);

      this.props.closeForm();
    } catch (error) {
      const status = error?.response?.status;
      const apiError = error?.response?.data?.error || "";
      const apiDetail = error?.response?.data?.detail || "";
      const apiCode = error?.response?.data?.code || "";

      if (status === 400 || status === 409) {
        if (apiCode === "EFFECTIVE_DATE_CANNOT_BE_FUTURE") {
          this.setState({ generalError: "No se puede seleccionar una fecha futura." });
          return;
        }
        if (apiError.toLowerCase().includes("serialnumber")) {
          if (this.serialDebounceTimer) clearTimeout(this.serialDebounceTimer);
          this.serialCheckSeq += 1;

          this.setState({ serialError: "Ya existe, elegir otro", generalError: "" });
          return;
        }

        this.setState({
          generalError:
            apiError ||
            apiDetail ||
            "No se pudo crear la máquina. Verifica que exista el Local Taller.",
        });
        return;
      }

      this.setState({
        generalError: "No se pudo crear la máquina. Intenta nuevamente.",
      });
      console.error("Hubo un error al crear o editar la máquina:", error);
    }
  };

  componentWillUnmount() {
    if (this.serialDebounceTimer) clearTimeout(this.serialDebounceTimer);
  }

  render() {
    const hasType = !!this.state.machine.MachineTypeId;
    const hasMachineData =
      this.state.machine.Name.trim().length > 0 &&
      this.state.machine.SerialNumber.trim().length > 0 &&
      !this.state.serialError;

    const disableMachineData = !hasType;
    const disableDateAndSave = !hasMachineData;
    const creationDateError = this.getCreationDateErrorMessage();
    const today = getDefaultOperationDate();

    return (
      <Paper style={{ padding: 20, marginTop: 10, width: "100%" }}>
        <form onSubmit={this.handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
                options={this.state.machineTypes}
                getOptionLabel={(option) => option?.Type || ""}
                value={this.state.selectedMachineType}
                onChange={(event, value) =>
                  this.handleAutocompleteChange("MachineTypeId", event, value)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo de máquina"
                    required
                    placeholder="Selecciona un tipo"
                    fullWidth
                    error={this.state.showRequiredErrors && !hasType}
                    helperText={this.state.showRequiredErrors && !hasType ? "Seleccioná un tipo de máquina." : ""}
                  />
                )}
                disabled={this.state.isLoading}
              />
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Nombre"
                    required
                    name="Name"
                    value={this.state.machine.Name}
                    onChange={this.handleChange}
                    disabled={disableMachineData}
                    error={this.state.showRequiredErrors && hasType && !this.state.machine.Name.trim()}
                    helperText={this.state.showRequiredErrors && hasType && !this.state.machine.Name.trim() ? "Ingresá un nombre." : ""}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Nro. Serie"
                    required
                    name="SerialNumber"
                    value={this.state.machine.SerialNumber}
                    onChange={this.handleChange}
                    disabled={disableMachineData}
                    error={Boolean(this.state.serialError || (this.state.showRequiredErrors && hasType && !this.state.machine.SerialNumber.trim()))}
                    helperText={
                      this.state.serialError ||
                      (this.state.showRequiredErrors && hasType && !this.state.machine.SerialNumber.trim() ? "Ingresá un número de serie." : "")
                    }
                  />
                  {hasType && this.state.serialSuggestion &&
                    this.state.machine.SerialNumber.trim() !== String(this.state.serialSuggestion).trim() && (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mt: 1 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
                        Nro. sugerido: {this.state.serialSuggestion}
                      </Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={this.applySuggestion}
                        sx={{ ...secondaryOutlinedButtonSx, minWidth: 160, whiteSpace: "nowrap" }}
                      >
                        Usar {this.state.serialSuggestion}
                      </Button>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                <DatePicker
                  label="Fecha de creación"
                  slotProps={{ textField: { required: true, fullWidth: true, error: Boolean(creationDateError), helperText: creationDateError } }}
                  value={this.state.machine.CreationDate}
                  onChange={this.handleDateChange}
                  disabled={disableDateAndSave}
                  maxDate={today}
                />
              </LocalizationProvider>
            </Grid>

            {/* ===================== BOTONES FINALES ===================== */}
            <Grid item xs={12} sx={{ mt: 1 }}>
              {this.state.generalError ? (
                <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                  {this.state.generalError}
                </Typography>
              ) : null}
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <CancelButton onClick={this.props.closeForm} fullWidth />
                </Grid>

                <Grid item xs={12} md={6}>
                  <AcceptButton
                    type="submit"
                    disabled={this.state.isLoading}
                    fullWidth
                  >
                    Crear máquina
                  </AcceptButton>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
        </form>
      </Paper>
    );
  }
}

 CreateMachineForm.propTypes = {
   closeForm: PropTypes.func.isRequired,
   onCreateSuccess: PropTypes.func,
 };

export default CreateMachineForm;




